import { useTranslation } from 'react-i18next'

import { Formik } from 'formik'
import * as Yup from 'yup'

import { phoneNumberRegex } from 'common/components/utils/InputUtils'

import { DefaultCheckboxV2, Icon, InputMask, Modal } from 'common/components'

interface SmsStatusUpdateModalProps {
  visible: boolean
  defaultPhone?: string | null
  onSubmit: (phone: string) => void
  onCancel: (rememberMe?: boolean) => void
}

export type SmsStatus = {
  phone: string
  rememberMe?: boolean
}

const SmsStatusUpdateModal = ({ visible, defaultPhone = null, onSubmit, onCancel }: SmsStatusUpdateModalProps) => {
  const { t: translate } = useTranslation()

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={{
        phone: defaultPhone,
        rememberMe: false,
      }}
      onSubmit={(values: SmsStatus) => onSubmit(values.phone)}
    >
      {(formik) => {
        const { handleSubmit } = formik
        return (
          <Modal
            title="Sign up for SMS Status Updates"
            visible={visible}
            destroyOnClose
            closable
            onCancel={() => onCancel(formik.values.rememberMe)}
            onOk={() => handleSubmit()}
            cancelText="Maybe later"
            okButtonProps={{
              disabled: !formik.isValid,
            }}
          >
            <form autoComplete="off" className="color-gray-9 gap-16 grid">
              <div>
                <div>Do you want to be notified via SMS when your request gets approved?</div>
                {defaultPhone === null && <div>Enter your phone number to opt in.</div>}
              </div>
              {defaultPhone === null && (
                <div>
                  <InputMask
                    label="Phone number"
                    name="phone"
                    mask="(000) 000-0000"
                    placeholder="(555) 123-4567"
                    suffix={<Icon className="far fa-phone" style={{ color: '#ADB5C0' }} />}
                  />
                </div>
              )}
              <div className="italic">
                By opting in, I agree to receive text messages from PeopleKeep. Message frequency varies. Message and
                data rates may apply.
              </div>
              <div className="flex gap-8">
                <DefaultCheckboxV2 name="rememberMe" />
                <div>Don't show this again</div>
              </div>
            </form>
          </Modal>
        )
      }}
    </Formik>
  )
}

const formValidator = (translate: (key: string) => string) =>
  Yup.object({
    phone: Yup.string()
      .required(translate('general.required'))
      .matches(phoneNumberRegex, translate('admin-signup.company-details.errors.phone-number-regex'))
      .nullable(),
  })

export default SmsStatusUpdateModal
